import React from 'react';
import { Badge, ConfigProvider } from 'antd';
import useDefaultTrebbleAntDTokenConfig from '../helper/useDefaultTrebbleAntDTokenConfig';

interface TrebbleBadgeProps {
  count?: React.ReactNode;
  dot?: boolean;
  offset?: [number, number];
  overflowCount?: number;
  showZero?: boolean;
  status?: 'success' | 'processing' | 'default' | 'error' | 'warning';
  text?: React.ReactNode;
  title?: string;
  color?: string;
  size?: 'default' | 'small';
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const TrebbleBadge: React.FC<TrebbleBadgeProps> = ({
  count,
  dot = false,
  offset,
  overflowCount = 99,
  showZero = false,
  status,
  text,
  title,
  color,
  size = 'default',
  className = '',
  style,
  children,
  ...props
}) => {
  const tokenConfig = useDefaultTrebbleAntDTokenConfig();
  
  const combinedClassName = `trebble-badge ${className}`;
  
  return (
    <ConfigProvider theme={tokenConfig}>
      <Badge
        count={count}
        dot={dot}
        offset={offset}
        overflowCount={overflowCount}
        showZero={showZero}
        status={status}
        text={text}
        title={title}
        color={color}
        size={size}
        className={combinedClassName}
        style={style}
        {...props}
      >
        {children}
      </Badge>
    </ConfigProvider>
  );
};

export default TrebbleBadge; 